(function () {
  'use strict';
  const CORE_SECTIONS = ['cart-bubble'];
  const DEFAULT_CONFIG = {
    storageKey: 'lop_save_for_later_v1',
    ttlHours: 24,
    sectionKey: 'main-cart',
    sectionTargets: [],
    strings: {}
  };
  const extraTargets = [];
  function getConfig() {
    return Object.assign({}, DEFAULT_CONFIG, window.lopSaveForLaterConfig || {});
  }
  function getStorageKey() {
    return getConfig().storageKey;
  }
  function getTtlMs() {
    const hours = Number(getConfig().ttlHours) || 24;
    return hours * 60 * 60 * 1000;
  }
  function getStrings() {
    return getConfig().strings || {};
  }
  function escapeHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
  function generateId() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return crypto.randomUUID();
    }
    return 'sfl_' + Date.now() + '_' + Math.random().toString(36).slice(2, 9);
  }
  function readStorage() {
    try {
      const raw = localStorage.getItem(getStorageKey());
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }
  function writeStorage(items) {
    try {
      localStorage.setItem(getStorageKey(), JSON.stringify(items));
      return true;
    } catch (e) {
      return false;
    }
  }
  function propertiesKey(properties) {
    try {
      return JSON.stringify(properties || {});
    } catch (e) {
      return '{}';
    }
  }
  function itemDedupeKey(variantId, properties) {
    return String(variantId) + '::' + propertiesKey(properties);
  }
  function parseProperties(raw) {
    if (!raw || raw === '{}') return {};
    try {
      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') return {};
      const filtered = {};
      Object.keys(parsed).forEach((key) => {
        if (key.charAt(0) !== '_') filtered[key] = parsed[key];
      });
      return filtered;
    } catch (e) {
      return {};
    }
  }
  function purgeExpired() {
    const now = Date.now();
    const ttl = getTtlMs();
    const items = readStorage().filter((item) => {
      const savedAt = Number(item.savedAt) || 0;
      return now - savedAt < ttl;
    });
    writeStorage(items);
    return items;
  }
  function upsertItem(entry) {
    const key = itemDedupeKey(entry.variantId, entry.properties);
    const items = readStorage().filter(
      (item) => itemDedupeKey(item.variantId, item.properties) !== key
    );
    items.push(entry);
    return writeStorage(items) ? items : null;
  }
  function removeById(id) {
    const items = readStorage().filter((item) => item.id !== id);
    writeStorage(items);
    return items;
  }
  function buildEntryFromButton(btn) {
    const ds = btn.dataset;
    const properties = parseProperties(ds.properties);
    const sellingPlanId = ds.sellingPlanId ? Number(ds.sellingPlanId) : null;
    return {
      id: generateId(),
      variantId: Number(ds.variantId),
      quantity: Number(ds.quantity) || 1,
      properties,
      sellingPlanId: sellingPlanId || null,
      savedAt: Date.now(),
      snapshot: {
        title: ds.title || '',
        url: ds.productUrl || '',
        image: ds.image || '',
        variantLabel: ds.variantLabel || '',
        priceFormatted: ds.priceFormatted || '',
        priceCents: Number(ds.priceCents) || 0
      }
    };
  }
  function resolveSectionHost(sectionKey, hostSelector) {
    if (hostSelector) {
      const el = document.querySelector(hostSelector);
      if (el) return el;
    }
    const exact = document.getElementById('shopify-section-' + sectionKey);
    if (exact) return exact;
    return document.querySelector('[id^="shopify-section-"][id$="__' + sectionKey + '"]')
      || document.querySelector('[id^="shopify-section-"][id*="' + sectionKey + '"]');
  }
  function getSectionsMap(parsedState) {
    if (!parsedState) return null;
    if (parsedState.sections) return parsedState.sections;
    if (parsedState['main-cart'] || parsedState['cart-bubble']) return parsedState;
    return null;
  }
  function getMainCartSectionKey() {
    return getConfig().sectionKey || 'main-cart';
  }
  function normalizeTarget(raw) {
    if (!raw || !raw.section) return null;
    return {
      section: String(raw.section),
      host: raw.host ? String(raw.host) : null,
      selector: raw.selector ? String(raw.selector) : null
    };
  }
  function getConfiguredTargets() {
    const fromConfig = (getConfig().sectionTargets || []).map(normalizeTarget).filter(Boolean);
    const seen = new Set();
    return fromConfig.concat(extraTargets).filter((t) => {
      if (seen.has(t.section)) return false;
      seen.add(t.section);
      return true;
    });
  }
  function getDiscoveredFragmentKeys() {
    const keys = new Set();
    document.querySelectorAll('[data-lop-cart-fragment]').forEach((el) => {
      const key = el.getAttribute('data-lop-cart-fragment');
      if (key) keys.add(key);
    });
    return Array.from(keys);
  }
  function getExtraSectionKeys() {
    const mainKey = getMainCartSectionKey();
    const keys = new Set();
    getConfiguredTargets().forEach((t) => {
      if (t.section !== mainKey && CORE_SECTIONS.indexOf(t.section) === -1) {
        keys.add(t.section);
      }
    });
    getDiscoveredFragmentKeys().forEach((k) => {
      if (k !== mainKey && CORE_SECTIONS.indexOf(k) === -1) keys.add(k);
    });
    return Array.from(keys);
  }
  function getSectionsPayload() {
    const mainKey = getMainCartSectionKey();
    const sections = [mainKey].concat(CORE_SECTIONS).concat(getExtraSectionKeys());
    return {
      sections: sections.filter((id, i, arr) => arr.indexOf(id) === i),
      sections_url: window.location.pathname
    };
  }
  let statusTimer;
  let pendingRemoveId = null;
  let removeModalLastFocus = null;
  function getRemoveModal() {
    return document.getElementById('lop-sfl-remove-modal');
  }
  function syncRemoveModalCopy() {
    const modal = getRemoveModal();
    if (!modal) return;
    const s = getStrings();
    const title = modal.querySelector('#lop-sfl-remove-modal-title');
    const message = modal.querySelector('#lop-sfl-remove-modal-message');
    const confirmBtn = modal.querySelector('[data-lop-sfl-remove-confirm]');
    const cancelBtn = modal.querySelector('.lop-sfl-remove-modal__btn--cancel');
    if (title && s.removeModalTitle) title.textContent = s.removeModalTitle;
    if (message && s.removeModalMessage) message.textContent = s.removeModalMessage;
    if (confirmBtn && s.removeModalConfirm) confirmBtn.textContent = s.removeModalConfirm;
    if (cancelBtn && s.removeModalCancel) cancelBtn.textContent = s.removeModalCancel;
  }
  function closeRemoveModal() {
    const modal = getRemoveModal();
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('lop-sfl-remove-modal-open');
    pendingRemoveId = null;
    if (removeModalLastFocus && typeof removeModalLastFocus.focus === 'function') {
      removeModalLastFocus.focus();
    }
    removeModalLastFocus = null;
  }
  function openRemoveModal(id) {
    const modal = getRemoveModal();
    if (!modal) return;
    syncRemoveModalCopy();
    pendingRemoveId = id;
    removeModalLastFocus = document.activeElement;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lop-sfl-remove-modal-open');
    const confirmBtn = modal.querySelector('[data-lop-sfl-remove-confirm]');
    if (confirmBtn) confirmBtn.focus();
  }
  function confirmRemoveModal() {
    if (!pendingRemoveId) return;
    removeById(pendingRemoveId);
    closeRemoveModal();
    render();
  }
  function bindRemoveModal() {
    const modal = getRemoveModal();
    if (!modal || modal.dataset.lopSflRemoveBound) return;
    modal.dataset.lopSflRemoveBound = 'true';
    modal.addEventListener('click', (event) => {
      if (event.target.closest('[data-lop-sfl-remove-dismiss]')) {
        event.preventDefault();
        closeRemoveModal();
        return;
      }
      if (event.target.closest('[data-lop-sfl-remove-confirm]')) {
        event.preventDefault();
        confirmRemoveModal();
      }
    });
    document.addEventListener('keydown', (event) => {
      if (modal.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeRemoveModal();
      }
    });
  }
  function getThemeCart() {
    return document.querySelector('theme-cart');
  }
  function setCartBusy(busy) {
    const form = document.getElementById('cart-form');
    if (form) form.classList.toggle('cart-disabled', busy);
  }
  function setLineLoading(line, busy) {
    if (!line) return;
    const row = document.getElementById('CartItem-' + line);
    if (row) row.classList.toggle('loading', busy);
  }
  function dispatchCartEvent(name, detail) {
    if (typeof dispatchCustomEvent === 'function') {
      dispatchCustomEvent(name, detail);
    }
  }
  function showCartStatus(message) {
    const el = document.getElementById('lop-cart-status');
    if (!el || !message) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(statusTimer);
    statusTimer = setTimeout(() => {
      el.hidden = true;
      el.textContent = '';
    }, 4000);
  }
  function getSectionHtml(sectionsMap, sectionKey) {
    if (!sectionsMap) return null;
    return sectionsMap[sectionKey] || null;
  }
  function applySelectorSwap(host, sectionHtml, selector) {
    const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const fragment = doc.querySelector(selector);
    const target = host.querySelector(selector) || host;
    if (fragment && target) {
      target.innerHTML = fragment.innerHTML;
      return true;
    }
    return false;
  }
  function applyFragmentTargets(sectionsMap) {
    document.querySelectorAll('[data-lop-cart-fragment]').forEach((host) => {
      const key = host.getAttribute('data-lop-cart-fragment');
      const html = getSectionHtml(sectionsMap, key);
      if (!key || !html) return;
      const selector = host.getAttribute('data-lop-cart-selector');
      if (selector && applySelectorSwap(host, html, selector)) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-lop-cart-fragment="' + key + '"]');
      if (fresh) {
        host.innerHTML = fresh.innerHTML;
        return;
      }
      const sectionHost = resolveSectionHost(key);
      const freshHost = sectionHost
        ? doc.getElementById(sectionHost.id) || doc.querySelector('[id="' + sectionHost.id + '"]')
        : null;
      if (freshHost) {
        host.innerHTML = freshHost.innerHTML;
        return;
      }
      const root = doc.body && doc.body.firstElementChild;
      if (root) host.innerHTML = root.innerHTML;
    });
  }
  function applySectionTarget(target, sectionsMap) {
    const html = getSectionHtml(sectionsMap, target.section);
    if (!html) return;
    const host = resolveSectionHost(target.section, target.host);
    if (!host) return;
    if (target.selector && applySelectorSwap(host, html, target.selector)) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const freshHost =
      doc.getElementById(host.id) ||
      doc.querySelector('[id^="shopify-section-"][id*="' + target.section + '"]');
    if (freshHost) {
      host.innerHTML = freshHost.innerHTML;
      return;
    }
    const root = doc.body && doc.body.firstElementChild;
    if (root) host.innerHTML = root.innerHTML;
  }
  function applyCartSections(parsedState) {
    const sectionKey = getMainCartSectionKey();
    const sectionsMap = getSectionsMap(parsedState);
    const cartHost = document.getElementById('Cart');
    if (!cartHost || !sectionsMap) return;
    const html = getSectionHtml(sectionsMap, sectionKey);
    if (html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const freshForm = doc.querySelector('.thb-cart-form');
      const liveForm = cartHost.querySelector('.thb-cart-form');
      const isNowEmpty = freshForm && freshForm.classList.contains('thb-cart-form--empty');
      const isLiveEmpty =
        !liveForm ||
        liveForm.classList.contains('thb-cart-form--empty') ||
        !liveForm.querySelector('.thb-cart-form--items');
      applySelectorSwap(cartHost, html, '.thb-cart-form--count');
      if (freshForm && liveForm && (isNowEmpty || isLiveEmpty)) {
        liveForm.className = freshForm.className;
        liveForm.innerHTML = freshForm.innerHTML;
      } else if (liveForm) {
        ['.thb-cart-form--items', '.thb-cart-form--collaterals'].forEach((sel) => {
          applySelectorSwap(cartHost, html, sel);
        });
      }
    }
    const bubbleHost = document.getElementById('cart-drawer-toggle');
    const bubbleHtml = getSectionHtml(sectionsMap, 'cart-bubble');
    if (bubbleHost && bubbleHtml) {
      const doc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
      ['.thb-secondary-area--item-count', '.thb-secondary-area--item-amount'].forEach((sel) => {
        const fragment = doc.querySelector(sel);
        const target = bubbleHost.querySelector(sel);
        if (fragment && target) target.innerHTML = fragment.innerHTML;
      });
    }
    const themeCart = getThemeCart();
    if (themeCart && typeof themeCart.setupEventListeners === 'function') {
      themeCart.setupEventListeners();
    }
  }
  function applyExtraSectionTargets(parsedState) {
    const sectionsMap = getSectionsMap(parsedState);
    if (!sectionsMap) return;
    getConfiguredTargets().forEach((target) => {
      applySectionTarget(target, sectionsMap);
    });
    applyFragmentTargets(sectionsMap);
    dispatchCartEvent('lop-cart:sections-updated', {
      sections: Object.keys(sectionsMap),
      cart: parsedState
    });
  }
  function fetchSections(sectionKeys) {
    const keys = (sectionKeys || []).filter(Boolean);
    if (!keys.length) return Promise.resolve({});
    const url =
      window.location.pathname +
      (window.location.pathname.indexOf('?') === -1 ? '?' : '&') +
      'sections=' +
      encodeURIComponent(keys.join(','));
    return fetch(url)
      .then((res) => res.json())
      .catch(() => ({}));
  }
  function refreshExtraSections(parsedState) {
    const sectionsMap = getSectionsMap(parsedState) || {};
    const extraKeys = getExtraSectionKeys();
    const missing = extraKeys.filter((key) => !getSectionHtml(sectionsMap, key));
    if (!missing.length) {
      applyExtraSectionTargets(parsedState);
      return Promise.resolve(parsedState);
    }
    return fetchSections(missing).then((fetched) => {
      const merged = Object.assign({}, sectionsMap, fetched);
      const mergedState = Object.assign({}, parsedState || {}, { sections: merged });
      applyExtraSectionTargets(mergedState);
      return mergedState;
    });
  }
  function liveCartIsEmpty() {
    const cartHost = document.getElementById('Cart');
    if (!cartHost) return false;
    const liveForm = cartHost.querySelector('.thb-cart-form');
    return (
      !liveForm ||
      liveForm.classList.contains('thb-cart-form--empty') ||
      !liveForm.querySelector('.thb-cart-form--items')
    );
  }
  function stateFormIsEmpty(parsedState) {
    const sectionsMap = getSectionsMap(parsedState);
    const html = sectionsMap && getSectionHtml(sectionsMap, getMainCartSectionKey());
    if (!html) return false;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const form = doc.querySelector('.thb-cart-form');
    return !!(form && form.classList.contains('thb-cart-form--empty'));
  }
  function rebuildCartFromFullPage() {
    const routes = window.theme && window.theme.routes;
    const url = routes && routes.cart_url ? routes.cart_url : '/cart';
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then((res) => res.text())
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const freshCart = doc.getElementById('Cart');
        const liveCart = document.getElementById('Cart');
        if (freshCart && liveCart) {
          liveCart.innerHTML = freshCart.innerHTML;
        }
        const themeCart = getThemeCart();
        if (themeCart && typeof themeCart.setupEventListeners === 'function') {
          themeCart.setupEventListeners();
        }
      })
      .catch(() => {});
  }
  function renderCartFromState(parsedState, line) {
    if (liveCartIsEmpty() && !stateFormIsEmpty(parsedState)) {
      if (line) setLineLoading(line, false);
      return rebuildCartFromFullPage().then(() => refreshExtraSections(parsedState));
    }
    applyCartSections(parsedState);
    if (line) setLineLoading(line, false);
    return refreshExtraSections(parsedState);
  }
  function patchThemeCartRenderContents() {
    const themeCart = getThemeCart();
    if (!themeCart || themeCart._lopRenderPatched) return;
    if (typeof themeCart.renderContents !== 'function') return;
    themeCart._lopRenderPatched = true;
    themeCart.renderContents = function (parsedState, line) {
      applyCartSections(parsedState);
      if (line) {
        const row = this.form && this.form.querySelector('#CartItem-' + line);
        if (row) row.classList.remove('loading');
      }
    };
  }
  function changeCartLine(line, quantity) {
    const routes = window.theme && window.theme.routes;
    if (!routes || !routes.cart_change_url) {
      return Promise.reject(new Error('cart_change_url missing'));
    }
    const body = JSON.stringify(
      Object.assign({ line: Number(line), quantity: Number(quantity) }, getSectionsPayload())
    );
    return fetch(routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body
    })
      .then((res) => res.text())
      .then((state) => (typeof state === 'string' ? JSON.parse(state) : state));
  }
  function fetchCart() {
    const routes = window.theme && window.theme.routes;
    const url = routes && routes.cart_url ? routes.cart_url + '.js' : '/cart.js';
    return fetch(url, { headers: { Accept: 'application/json' } }).then((res) => res.json());
  }
  function addToCart(entry) {
    const routes = window.theme && window.theme.routes;
    const url = routes && routes.cart_add_url ? routes.cart_add_url + '.js' : '/cart/add.js';
    const item = {
      id: entry.variantId,
      quantity: entry.quantity,
      properties: entry.properties || {}
    };
    if (entry.sellingPlanId) {
      item.selling_plan = entry.sellingPlanId;
    }
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.assign({ items: [item] }, getSectionsPayload()))
    }).then(async (res) => {
      const data = await res.json();
      if (!res.ok) {
        const message =
          (typeof data.description === 'string' && data.description) ||
          (typeof data.message === 'string' && data.message) ||
          getStrings().addError;
        throw new Error(message);
      }
      return data;
    });
  }
  function isVariantInCart(cart, variantId) {
    if (!cart || !cart.items) return false;
    return cart.items.some((line) => line.variant_id === Number(variantId));
  }
  function normalizeVariantLabel(label) {
    if (!label) return '';
    return label
      .split('|')
      .map((part) => {
        const piece = part.trim();
        const colon = piece.indexOf(':');
        return colon >= 0 ? piece.slice(colon + 1).trim() : piece;
      })
      .filter(Boolean)
      .join(' | ');
  }
  function formatItemCount(count) {
    const s = getStrings();
    if (count === 1) {
      return s.itemCountOne || '(1 artículo)';
    }
    const tpl = s.itemCountOther || '({count} artículos)';
    return tpl.replace('{count}', String(count));
  }
  function renderItemCard(item, s) {
    const snap = item.snapshot || {};
    const img = snap.image
      ? '<img src="' + escapeHtml(snap.image) + '" alt="" width="120" height="120" loading="lazy">'
      : '';
    const variantLabel = normalizeVariantLabel(snap.variantLabel);
    const variant = variantLabel
      ? '<div class="product-cart-item-options">' + escapeHtml(variantLabel) + '</div>'
      : '';
    const price = snap.priceFormatted
      ? '<div class="price"><span class="amount">' + escapeHtml(snap.priceFormatted) + '</span></div>'
      : '';
    return (
      '<article class="lop-sfl-item" role="listitem" data-sfl-id="' +
      escapeHtml(item.id) +
      '">' +
      '<div class="lop-sfl-item__image"><a href="' +
      escapeHtml(snap.url) +
      '">' +
      img +
      '</a></div>' +
      '<div class="lop-sfl-item__body">' +
      '<div class="lop-sfl-item__top">' +
      '<a class="cart-product-link lop-sfl-item__title" href="' +
      escapeHtml(snap.url) +
      '">' +
      escapeHtml(snap.title) +
      '</a>' +
      '<button type="button" class="lop-sfl-item__remove-icon lop-sfl-remove" data-sfl-id="' +
      escapeHtml(item.id) +
      '" aria-label="' +
      escapeHtml(s.remove) +
      '">' +
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
      '</button></div>' +
      price +
      variant +
      '<div class="lop-sfl-item__actions">' +
      '<button type="button" class="lop-sfl-action lop-sfl-move" data-sfl-id="' +
      escapeHtml(item.id) +
      '">' +
      '<svg class="lop-sfl-action__icon" width="15" height="15" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><use href="#cart"></use></svg>' +
      '<span class="lop-sfl-action__label">' +
      escapeHtml(s.moveToBag) +
      '</span></button></div>' +
      '<div class="lop-sfl-item__error" hidden></div></div></article>'
    );
  }
  function render() {
    const root = document.getElementById('lop-save-for-later');
    const list = document.getElementById('lop-sfl-list');
    const countEl = root && root.querySelector('[data-lop-sfl-count]');
    if (!root || !list) return;
    const items = purgeExpired();
    const s = getStrings();
    if (items.length === 0) {
      root.hidden = true;
      list.innerHTML = '';
      if (countEl) countEl.textContent = '';
      return;
    }
    root.hidden = false;
    if (countEl) countEl.textContent = formatItemCount(items.length);
    list.innerHTML = items.map((item) => renderItemCard(item, s)).join('');
  }
  function escapeSelectorValue(value) {
    if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') {
      return CSS.escape(String(value));
    }
    return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }
  function setItemLoading(id, loading) {
    const card = document.querySelector('.lop-sfl-item[data-sfl-id="' + escapeSelectorValue(id) + '"]');
    if (!card) return;
    card.classList.toggle('lop-sfl-item--loading', loading);
    card.querySelectorAll('button').forEach((btn) => {
      btn.disabled = loading;
    });
  }
  function showItemError(id, message) {
    const card = document.querySelector('.lop-sfl-item[data-sfl-id="' + escapeSelectorValue(id) + '"]');
    if (!card) return;
    const err = card.querySelector('.lop-sfl-item__error');
    if (!err) return;
    if (message) {
      err.textContent = message;
      err.hidden = false;
    } else {
      err.textContent = '';
      err.hidden = true;
    }
  }
  function handleSave(btn) {
    const s = getStrings();
    const line = btn.dataset.line;
    if (!line) return;
    const entry = buildEntryFromButton(btn);
    if (!entry.variantId) return;
    btn.disabled = true;
    const saved = upsertItem(entry);
    if (!saved) {
      btn.disabled = false;
      window.alert(s.storageError || 'No se pudo guardar.');
      return;
    }
    render();
    setCartBusy(true);
    setLineLoading(line, true);
    dispatchCartEvent('line-item:change:start', { quantity: 0, source: 'lop-save-for-later' });
    changeCartLine(line, 0)
      .then((parsed) => {
        if (parsed.errors) {
          throw new Error(
            typeof parsed.errors === 'string' ? parsed.errors : s.addError
          );
        }
        return renderCartFromState(parsed, line).then(() => parsed);
      })
      .then((parsed) => {
        showCartStatus(s.savedToLater);
        dispatchCartEvent('line-item:change:end', {
          quantity: 0,
          cart: parsed,
          source: 'lop-save-for-later'
        });
        dispatchCartEvent('lop-cart:updated', { action: 'save-for-later', cart: parsed });
        render();
      })
      .catch(() => {
        removeById(entry.id);
        render();
        window.alert(s.addError || 'No se pudo actualizar el carrito.');
      })
      .finally(() => {
        setCartBusy(false);
        setLineLoading(line, false);
        btn.disabled = false;
      });
  }
  function handleMove(id) {
    const s = getStrings();
    const items = readStorage();
    const entry = items.find((item) => item.id === id);
    if (!entry) {
      render();
      return;
    }
    setItemLoading(id, true);
    showItemError(id, '');
    dispatchCartEvent('line-item:change:start', {
      quantity: entry.quantity,
      source: 'lop-save-for-later'
    });
    fetchCart()
      .then((cart) => {
        if (isVariantInCart(cart, entry.variantId)) {
          throw new Error(s.alreadyInCart || 'Este artículo ya está en el carrito.');
        }
        return addToCart(entry);
      })
      .then((parsed) => {
        removeById(id);
        render();
        return renderCartFromState(parsed).then(() => parsed);
      })
      .then((parsed) => {
        showCartStatus(s.movedToBag);
        dispatchCartEvent('line-item:change:end', {
          quantity: entry.quantity,
          cart: parsed,
          source: 'lop-save-for-later'
        });
        dispatchCartEvent('lop-cart:updated', { action: 'move-to-bag', cart: parsed });
      })
      .catch((err) => {
        showItemError(id, err.message || s.addError);
      })
      .finally(() => {
        setItemLoading(id, false);
      });
  }
  function handleRemove(id) {
    openRemoveModal(id);
  }
  function onLineItemChangeEnd(event) {
    render();
    const cart = event && event.detail && event.detail.cart;
    if (event && event.detail && event.detail.source === 'lop-save-for-later') return;
    if (!getExtraSectionKeys().length) return;
    refreshExtraSections(cart || {});
  }
  function bindEvents() {
    const cart = document.getElementById('Cart');
    const sflRoot = document.getElementById('lop-save-for-later');
    if (cart) {
      cart.addEventListener('click', (event) => {
        const saveBtn = event.target.closest('.lop-sfl-save');
        if (!saveBtn || !cart.contains(saveBtn)) return;
        event.preventDefault();
        handleSave(saveBtn);
      });
    }
    if (sflRoot) {
      sflRoot.addEventListener('click', (event) => {
        const moveBtn = event.target.closest('.lop-sfl-move');
        if (moveBtn) {
          event.preventDefault();
          handleMove(moveBtn.dataset.sflId);
          return;
        }
        const removeBtn = event.target.closest('.lop-sfl-remove');
        if (removeBtn) {
          event.preventDefault();
          handleRemove(removeBtn.dataset.sflId);
        }
      });
    }
    document.addEventListener('line-item:change:end', onLineItemChangeEnd);
    document.addEventListener('cart:refresh', render);
  }
  function init() {
    const root = document.getElementById('lop-save-for-later');
    if (!root) return;
    purgeExpired();
    render();
    bindRemoveModal();
    bindEvents();
    patchThemeCartRenderContents();
    window.addEventListener('load', patchThemeCartRenderContents, { once: true });
  }
  window.LOPCartPageRefresh = {
    registerTarget: function (target) {
      const normalized = normalizeTarget(target);
      if (!normalized) return;
      extraTargets.push(normalized);
    },
    getExtraSectionKeys: getExtraSectionKeys,
    fetchSections: fetchSections,
    applyFromState: function (parsedState) {
      return refreshExtraSections(parsedState);
    },
    refresh: function () {
      return fetchSections(getExtraSectionKeys()).then((sections) => {
        const state = { sections: sections };
        applyExtraSectionTargets(state);
        dispatchCartEvent('lop-cart:updated', { cart: state, action: 'refresh' });
        return state;
      });
    }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
